module.exports = __webpack_public_path__ + "img/woman.395ee0eb.svg";